export const toNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const formatInt = (value) => toNumber(value).toLocaleString();

export const formatDate = (value) => {
  if (!value) return '--';
  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return '--';
  }
};

export const formatDateTime = (value) => {
  if (!value) return '--';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return '--';
  }
};
